import { apiRequest } from '../../../api/client';
import type { AdminAccount, MfaSetupResponse, MfaStatusResponse } from '../../../api/types';

// PARA-114, AC-1: список admin-аккаунтов.
export async function fetchAdmins(): Promise<AdminAccount[]> {
  return apiRequest<AdminAccount[]>('/admin/admins');
}

// PARA-114, AC-2: создание admin-аккаунта.
export async function createAdmin(login: string, password: string): Promise<AdminAccount> {
  return apiRequest<AdminAccount>('/admin/admins', {
    method: 'POST',
    body: { login, password },
  });
}

// PARA-114, AC-3: деактивация admin-аккаунта.
export async function deactivateAdmin(adminId: number): Promise<AdminAccount> {
  return apiRequest<AdminAccount>(`/admin/admins/${adminId}/deactivate`, {
    method: 'POST',
  });
}

// PARA-114, AC-4: реактивация admin-аккаунта.
export async function reactivateAdmin(adminId: number): Promise<AdminAccount> {
  return apiRequest<AdminAccount>(`/admin/admins/${adminId}/reactivate`, {
    method: 'POST',
  });
}

// PARA-151, AC-1/AC-1.1: начало enrollment — новый TOTP-секрет
// (otpauth_uri для QR + plaintext-секрет). 422, если MFA уже включена.
export async function setupMfa(): Promise<MfaSetupResponse> {
  return apiRequest<MfaSetupResponse>('/admin/mfa/setup', {
    method: 'POST',
  });
}

// PARA-151, AC-2: подтверждение enrollment первым TOTP-кодом.
// 400 — неверный код, 422 — уже включена / setup не начат, 429 — rate-limit.
export async function enableMfa(totpCode: string): Promise<MfaStatusResponse> {
  return apiRequest<MfaStatusResponse>('/admin/mfa/enable', {
    method: 'POST',
    body: { totp_code: totpCode },
  });
}

// PARA-151, AC-6: отключение своей MFA текущим TOTP-кодом. После 200 все
// сессии аккаунта отозваны (AC-9) — вызывающий обязан явно разлогиниться.
export async function disableMfa(totpCode: string): Promise<MfaStatusResponse> {
  return apiRequest<MfaStatusResponse>('/admin/mfa/disable', {
    method: 'POST',
    body: { totp_code: totpCode },
  });
}

// PARA-151, AC-7: сброс MFA другого admin-аккаунта (без TOTP-кода).
// 404 — неизвестный admin, 422 — у целевого MFA не включена.
export async function resetMfa(adminId: number): Promise<AdminAccount> {
  return apiRequest<AdminAccount>(`/admin/admins/${adminId}/mfa/reset`, {
    method: 'POST',
  });
}
